import { Component } from '@angular/core';
import { NetworkStatus } from '@capacitor/network';
import { NetworkStatusService } from '@viso/core/utilities';

const slowNetwork = ['slow-2g', '2g', '3g'];

declare var navigator: any;

@Component({
  selector: 'viso-online-status',
  templateUrl: './online-status.component.html',
  styleUrls: ['./online-status.component.scss'],
  standalone: false,
})
export class OnlineStatusComponent {
  lastConnectionType: string;
  constructor(private networkStatus: NetworkStatusService) {
    this.networkStatusChange();
  }

  networkStatusChange() {
    this.networkStatus.networkStatusChange$.subscribe((res) => {
      this.lastConnectionType = res.connectionType;
      this.onNetworkChange(res);
    });
  }

  onNetworkChange(status: NetworkStatus) {
    const effectiveType = navigator.connection && slowNetwork.includes(navigator.connection['effectiveType'])
    if (status.connectionType === 'cellular' && effectiveType) {
      this.removeOnlineStatusElm();
      this.createOnlineStatusElm();
      return;
    }
    this.removeOnlineStatusElm();
  }

  createOnlineStatusElm() {
    const onlineStatusElm = document.createElement('div');
    onlineStatusElm.setAttribute('id', 'online-status');
    onlineStatusElm.className = 'online-status-footer';
    onlineStatusElm.innerHTML = `Slow network connection,pages may load slowly`;
    document.body.appendChild(onlineStatusElm);
    document.body.className = 'viso-online-status';
  }

  removeOnlineStatusElm() {
    const onlineStatusElm = document.getElementById('online-status');
    if (onlineStatusElm) document.body.removeChild(onlineStatusElm);
    if (document.body.className.includes('viso-online-status')) {
      document.body.className = document.body.className.replace(
        'viso-online-status',
        ''
      );
    }
  }
}
